import { __makeTemplateObject } from "tslib";
import { Link } from "react-router-dom";
import styled from "styled-components";
export var SearchItemStyles = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  height: 32px;\n  margin: ", ";\n  padding: ", ";\n  align-items: center;\n  gap: 10px;\n  flex: 1 0 0;\n  border-radius: ", ";\n  background: #fff;\n  text-decoration: none;\n  transform: all 0.3s;\n  white-space: nowrap;\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  position: relative;\n  display: flex;\n  height: 32px;\n  margin: ", ";\n  padding: ", ";\n  align-items: center;\n  gap: 10px;\n  flex: 1 0 0;\n  border-radius: ", ";\n  background: #fff;\n  text-decoration: none;\n  transform: all 0.3s;\n  white-space: nowrap;\n\n  color: ", ";\n  font-family: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "".concat(theme.spacing.xxs, " ").concat(theme.spacing.xs);
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme;
    return theme.radius.s;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.lightest;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.darker;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map